import {createSlice} from '@reduxjs/toolkit';
import {
  clearNewMeetingBuildingId,
  clearNewMeetingSelectedDateTimes,
  setIsNewMeetingAllDay,
  setIsNewMeetingOnline,
  setNewMeetingBuildingId,
  setNewMeetingInvitees,
  setNewMeetingSelectedEndDateTime,
  setNewMeetingSelectedStartDateTime,
  setNewMeetingMessage,
  setNewMeetingTitle,
  unsetNewMeeting,
  setNewMeetingRooms,
} from './actions';
import {getInitialState, getNewMeetingInitialState} from './initialState';

const initialState = getInitialState();
const newMeetingInitialState = getNewMeetingInitialState();

const slice = createSlice({
  name: 'ui/calendar',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setNewMeetingTitle, (state, action) => {
        state.newMeeting.title = action.payload;
      })
      .addCase(setNewMeetingSelectedStartDateTime, (state, {payload}) => {
        state.newMeeting.selectedStartDateTime = payload;
      })
      .addCase(setNewMeetingSelectedEndDateTime, (state, {payload}) => {
        state.newMeeting.selectedEndDateTime = payload;
      })
      .addCase(clearNewMeetingSelectedDateTimes, (state) => {
        const {selectedStartDateTime, selectedEndDateTime} = newMeetingInitialState;
        state.newMeeting.selectedStartDateTime = selectedStartDateTime;
        state.newMeeting.selectedEndDateTime = selectedEndDateTime;
      })
      .addCase(setNewMeetingMessage, (state, action) => {
        state.newMeeting.message = action.payload;
      })
      .addCase(setNewMeetingInvitees, (state, action) => {
        state.newMeeting.attendees = action.payload;
      })
      .addCase(setIsNewMeetingAllDay, (state, action) => {
        state.newMeeting.isAllDay = action.payload;
      })
      .addCase(setIsNewMeetingOnline, (state, action) => {
        state.newMeeting.isOnlineMeeting = action.payload;
      })
      .addCase(unsetNewMeeting, (state) => {
        state.newMeeting = newMeetingInitialState;
      })
      .addCase(setNewMeetingBuildingId, (state, action) => {
        state.newMeetingBuildingId = action.payload;
      })
      .addCase(clearNewMeetingBuildingId, (state) => {
        state.newMeetingBuildingId = initialState.newMeetingBuildingId;
      })
      .addCase(setNewMeetingRooms, (state, action) => {
        state.newMeeting.roomIds = action.payload;
      });
  },
});

export const {reducer: uiMeetingsReducer} = slice;
